import PanelRight from "src/Component/PanelRight";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import Screen9 from "./Screen9";
import FrameTV from "src/Component/FrameTV";
import BottomTV from "src/Component/BottomTV";

const PageId = 9;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const baseImageBG = `${Config.BASE_URL}/images/BG/`;

  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const [step, setStep] = useState<number>(0);

  useEffect(() => {
    setStep(PageId === currentPage ? 1 : 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const title = "Your Live TV, Anytime, Anywhere";

  const description =
    'Take control of your live TV experience with Infosys’\nadvanced Recording & Replay features. Never miss\na moment—whether it’s yesterday’s game, today’s\nbreaking news, or your favorite live show.\n\n<span style="font-weight:bold;text-decoration: underline; ">Record</span>\nHit ‘Record’ during live viewing, store it in ‘My\nRecordings,’ and watch it later at your convenience,\nstarting from the beginning.”';

  return {
    bgImage: `${baseImageBG}BG_2.jpg`,
    title,
    description,
    rightSideComponent: (
      <PanelRight>
        <FrameTV scrollDisabled={PageId === currentPage} scrollPosition={0} scrollTop={step >= 3}>
          <Screen9 step={step} setStep={setStep} pageId={PageId} />
        </FrameTV>
        <BottomTV showSkips={step < 6} backPageId={BackPageId} nextPageId={NextPageId} />
      </PanelRight>
    ),
    back: {
      label: "Back",
      type: "back",
      startIcon: { icon: "arrow-right", color: "#fff" },
      onClick: () => setCurrentPage(BackPageId),
      style: {
        gap: "var(--width-16)",
        opacity: step >= 4 ? 1 : 0,
        transition: step !== 0 ? "opacity 0.5s ease" : "",
        zIndex: step >= 4 ? 1 : -1,
      },
    },
    next: {
      label: "Continue",
      type: "next",
      endIcon: { icon: "arrow-left" },
      onClick: () => setCurrentPage(NextPageId),
      style: {
        gap: "var(--width-16)",
        opacity: step >= 4 ? 1 : 0,
        transition: step !== 0 ? "opacity 0.5s ease" : "",
        zIndex: step >= 4 ? 1 : -1,
      },
    },
  };
};

export default DATA;
